import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "15px 0px 15px 0px",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },

  divContainer1: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    "& > div": {
      flex: 1,
      minWidth: 0,
    },
    "@media (max-width:899.95px)": {
      flexDirection: "column",
      gap: "12px",
    },
  },
});

export default useStyles;
